<section [attr.id]="sectionId" [class]="sectionClassList">
  <div class="section-panel">
    <div class="section-header">
      <p class="section-title">{{ sectionTitle }}</p>
      <p class="section-results">{{ displayResults }} Results</p>
    </div>

    <div class="section-grid">
      <ng-content></ng-content>
    </div>

    <app-pagination-controls
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      [totalPages]="totalPages"
      [canGoPrev]="canGoPrev"
      [canGoNext]="canGoNext"
      (pageSizeChange)="pageSizeChange.emit($event)"
      (prevPage)="prevPage.emit()"
      (nextPage)="nextPage.emit()"></app-pagination-controls>
  </div>
</section>
